const video = {
	init: (): void => {
		video.controls();
		video.article();
	},

	controls: (): void => {
		const video = document.querySelectorAll(".video-overlay");

		if (video != null) {
			for (let i = 0; i < video.length; i++) {
				video[i].addEventListener("click", (evt) => {
					const videoPlayer = video[i].parentElement;

					if (videoPlayer != null) {
						const youtubeID = videoPlayer.getAttribute("data-youtube");
						const vimeoID = videoPlayer.getAttribute("data-vimeo");
						const mediaUrl = videoPlayer.getAttribute("data-media");

						if (youtubeID != "") {
							const youtubeString =
								"https://www.youtube.com/embed/" +
								youtubeID +
								"?&theme=dark&enablejsapi=1&autohide=1&showinfo=0&rel=0";

							videoPlayer.querySelector(".iframe").innerHTML =
								'<iframe title="YouTube video player" class="video-player" id="video " type="text/html"' +
								'src="' +
								youtubeString +
								'&autoplay=1" frameborder="0" allowFullScreen></iframe>';
						} else if (vimeoID != "") {
							const vimeoString =
								"https://player.vimeo.com/video/" +
								vimeoID +
								"?title=0&byline=0";

							videoPlayer.querySelector(".iframe").innerHTML =
								'<iframe title="Vimeo video player" class="video-player" id="video " type="text/html"' +
								'src="' +
								vimeoString +
								'&autoplay=1" frameborder="0" allowFullScreen></iframe>';
						} else if (mediaUrl != "") {
							videoPlayer.querySelector(".iframe").innerHTML =
								'<video class="media-player" preload="none" autoplay>' +
								'<source src="' +
								mediaUrl +
								'" type="video/mp4">' +
								"Your browser does not support the video tag." +
								"</video>";
						}
					}

					video[i].classList.remove("show");

					setTimeout(function () {
						video[i].classList.remove("open");
					}, 400);

					evt.preventDefault();
				});
			}
		}
	},

	article: (): void => {
		const article = document.querySelector(".article");

		if (article != null) {
			const aElement = article.querySelectorAll("a");

			for (let i = 0; i < aElement.length; i++) {
				if (aElement[i].href.indexOf("youtube") > -1) {
					const element = aElement[i];

					element.addEventListener("click", function (event) {
						event.preventDefault();
						const url = aElement[i].href.split("?v=");

						if (url != null) {
							const overlay = aElement[i].querySelector(".youtube-overlay");

							if (overlay == null) {
								const html = document.createElement("div");
								html.classList.add("youtube-overlay");
								html.innerHTML =
									'<iframe title= "YouTube video player" id="video" type= "text/html" src="https://www.youtube.com/embed/' +
									url[1] +
									'?&theme=dark&enablejsapi=1&autohide=1&showinfo=0&rel=0&autoplay=1" frameborder = "0" allowFullScreen></iframe >';
								aElement[i].appendChild(html);
							} else {
								overlay.remove();
							}
						}
					});
				}
			}
		}
	},
};

export default video;
